import "./ribbonMarquee.css";

type RibbonMarqueeProps = {
  text: string;
  speedSec?: number;
  divider?: string;
  direction?: "left" | "right";
  className?: string;
};

export const RibbonMarquee = ({
  text,
  speedSec = 40,
  direction = "left",
  divider = "      •      ",
  className = "",
}: RibbonMarqueeProps) => {
  const chunk = `${text}`;
  const chunkDivider = `${divider}`;
  const makeTrackText = () =>
    `${new Array(20).fill(chunk).join(chunkDivider)}${chunkDivider}`;
  const trackText = makeTrackText();

  return (
    <div
      className={`oc-ribbon ${
        direction === "right" ? "is-right" : ""
      } ${className}`}
      style={
        {
          ["--dur" as any]: `${speedSec}s`,
        } as any
      }
      aria-hidden="true"
    >
      <div className="oc-ribbon__inner">
        <div className="oc-ribbon__track">
          <span className="oc-ribbon__text">{trackText}</span>
          <span className="oc-ribbon__text">{trackText}</span>
        </div>
      </div>
    </div>
  );
};
